import React from 'react';

/** Video component stub — native player is not used on PWA v1. */
const Video = React.forwardRef<HTMLVideoElement, Record<string, unknown>>(function VideoStub(
  _props,
  _ref,
) {
  return null;
});

export default Video;
